// src/components/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import LogoLargo from '../Img/Logo_largo.png'; // Reutilizamos el logo

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      // Endpoint HIPOTÉTICO (aún no existe en tu backend)
      // Asegúrate de que tu backend use la misma URL base
      const response = await apiClient.post('/solicitar_reset', { email });
      
      setMessage(response.data.message || 'Se ha enviado un enlace de recuperación a tu correo.');
      setEmail('');
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error || 'No se pudo procesar la solicitud.');
      } else {
        setError('Error de conexión. Inténtalo de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-gray-900">
      <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent opacity-90"></div>
      
      <div className="relative bg-white/10 backdrop-blur-md p-10 rounded-2xl shadow-2xl w-full max-w-md z-10 text-white animate-slideInUp">
        <div className="flex justify-center mb-8">
          <img src={LogoLargo} alt="Logo" className="w-50 h-auto" />
        </div>
        <h2 className="text-3xl font-bold text-center mb-2">Recuperar Contraseña</h2>
        <p className="text-center text-gray-300 mb-8">
          Ingresa tu correo y te enviaremos un enlace para resetearla.
        </p>

        {message && (
          <div className="bg-green-500 bg-opacity-20 text-green-300 p-3 rounded-lg mb-4 text-center">
            {message}
          </div>
        )}
        {error && (
          <div className="bg-red-500 bg-opacity-20 text-red-300 p-3 rounded-lg mb-4 text-center">
            {error}
          </div>
        )}

        {!message && ( // Ocultar formulario si ya se envió el correo
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-200 text-sm font-semibold mb-2" htmlFor="email">
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl bg-white/20 border border-white/30 focus:border-purple-400 focus:outline-none text-white placeholder-gray-400 transition-all duration-300"
                placeholder="tu@correo.com"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-900 hover:bg-blue-950 text-white font-semibold py-3 rounded-xl transition-colors duration-300 shadow-md disabled:opacity-50"
            >
              {loading ? 'Enviando...' : 'Enviar Enlace'}
            </button>
          </form>
        )}

        <div className="text-center mt-6">
          <Link
            to="/login"
            className="text-gray-300 hover:text-white hover:underline text-sm transition-colors duration-300"
          >
            Volver a Iniciar Sesión
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;